import {createSlice, PayloadAction} from '@reduxjs/toolkit'
import {
  ResEEG,
  ResEEGMCI5Stages,
  ResEEGMCI8Stages,
  ResHRV,
  ResHealthReport,
} from 'api/languageApi'

interface LangType {
  eeg: ResEEG | null
  hrv: ResHRV | null
  mci: ResEEGMCI5Stages | ResEEGMCI8Stages | null
  health: ResHealthReport | null
}
export interface LanguageState {
  es: LangType
  en: LangType
  ko: LangType
  ja: LangType
  ro: LangType
  th: LangType
  zh: LangType
}

const createDefaultLangType = (): LangType => ({
  eeg: null,
  hrv: null,
  mci: null,
  health: null,
})

const initialState: LanguageState = {
  es: createDefaultLangType(),
  en: createDefaultLangType(),
  ko: createDefaultLangType(),
  ja: createDefaultLangType(),
  ro: createDefaultLangType(),
  th: createDefaultLangType(),
  zh: createDefaultLangType(),
}

const slice = createSlice({
  name: 'language',
  initialState,
  reducers: {
    updateReportLanguage(
      state,
      action: PayloadAction<{
        lang: keyof LanguageState
        type: keyof LangType
        data: LangType[keyof LangType]
      }>,
    ) {
      const {lang, type, data} = action.payload
      if (state[lang]) {
        state[lang] = {
          ...state[lang],
          [type]: data,
        }
      }
    },
  },
})

export default slice.reducer

export const {updateReportLanguage} = slice.actions

export const selectLanguageReport = (state: LanguageState) => state

export const getCurrentLanguageReport = (
  state: LanguageState,
  lang: string,
) => {
  switch (lang) {
    case 'es':
      return state.es
    case 'en':
      return state.en
    case 'ko':
      return state.ko
    case 'ja':
      return state.ja
    case 'ro':
      return state.ro
    case 'th':
      return state.th
    case 'zh':
      return state.zh

    default:
      return null
  }
}
